<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        v-if="avatarUrl"
        :variant="variant"
        size="3.5rem"
        class="mr-75 flex-shrink-0"
      >
        <img :src="avatarUrl" :alt="avatarAlt" class="avatar-image" />
      </b-avatar>
      <b-avatar
        v-else
        :variant="variant"
        size="3.5rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon :icon="icon" size="25" />
      </b-avatar>
      <div class="d-flex flex-grow-1">
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small v-if="text" class="d-inline-block text-body" v-html="text" />
        </div>
        <span
          class="cursor-pointer toastification-close-icon ml-auto"
          @click="$emit('close-toast')"
        >
          <feather-icon v-if="!hideClose" icon="XIcon" class="text-body" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";

export default {
  components: {
    BAvatar,
  },
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    avatarUrl: {
      type: String,
      default: null,
    },
    avatarAlt: {
      type: String,
      default: "Avatar",
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}

.avatar-image {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
</style>
